import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { Button } from '@mui/material';
import { Container, Content } from '../styles';
import { ReactComponent as IconAdd } from '../../../assets/icons/IconAdd.svg';
//import { useContacts } from '../../../context';
import { ModalCreateListFavorites } from '../../Modals/ModalCreateListFavorites';

export function MenuOptionLeftContacts() {
  const [isOpenModalCreateList, setIsOpenModalCreateList] = useState(false);
  //const { listsContactsUser, listCustomContactsSelectedId, setListCustomContactsSelectedId } = useContacts();

  const location = useLocation();
  // const handleSelectedListContacts = (contactId: string) => {
  //   setListCustomContactsSelectedId(contactId);
  //   navigate('/list-contacts');
  // };
  // useEffect(() => {
  //   if (location.pathname !== '/list-contacts') {
  //     setListCustomContactsSelectedId(undefined);
  //   }
  // }, [location.pathname, setListCustomContactsSelectedId]);
  return (
    <Container>
      <h1 className="Title">Contatos</h1>
      <Content>
        <div className="NavBarContacts">
          <div className="DivOption">
            <Link
              className={location.pathname === '/friends' ? 'LinkMenuLeftActive' : ''}
              to="/friends">
              Amigos
            </Link>
          </div>
          <div className="DivOption">
            <Link
              className={location.pathname === '/request' ? 'LinkMenuLeftActive' : ''}
              to="/request">
              Solicitações
            </Link>
          </div>
          <div className="DivOption">
            <Link
              className={location.pathname === '/sugestion' ? 'LinkMenuLeftActive' : ''}
              to="/sugestion">
              Sugestões
            </Link>
          </div>
        </div>
      </Content>
      <div className="add-list-favorites">
        <h3>Lista de favoritos</h3>
        <div className="add-list-contact">
          <Button
            className="button-add"
            type="button"
            onClick={() => setIsOpenModalCreateList(true)}>
            Adicionar lista
            <IconAdd />
          </Button>
        </div>
        <div className="list-lists-contacts">
          {/* {listsContactsUser.map((customContact) =>
          (
            <div key={customContact.id} className='item-list'>
              <Button className={listCustomContactsSelectedId === customContact.id ? 'selected-list' : 'select-list'}
                onClick={() => handleSelectedListContacts(customContact.id)}
                title={customContact.name}
                style={{ textTransform: 'none' }}
              >
                <div className='select-item-info'>
                  {customContact.photo?.url ?
                    (
                      <img className='content-photo-list' src={customContact.photo.url} alt="" />
                    ) :
                    (
                      <div className='content-photo-list'><RecentActorsIcon /></div>
                    )
                  }
                  <p>{customContact.name}</p>
                </div>
              </Button>
            </div>
          ))
          } */}
        </div>
      </div>
      <ModalCreateListFavorites
        isOpen={isOpenModalCreateList}
        onRequestClose={() => setIsOpenModalCreateList(false)}
      />
    </Container>
  );
}
